import * as type from './mutations_type.js'
import Vue from 'vue'

export default {
  //保存医生登录手机
  [type.SAVE_LOGIN_PHONE](state, { loginPhone }) {
    state.loginPhone = loginPhone;
    Vue.prototype.$session.save('loginPhone', loginPhone);
  },

  //设置摄像头信息
  [type.SET_CAMERA_INFO](state, { cameraStatus }) {
    state.isHasCamera = cameraStatus;
    Vue.prototype.$session.save('isHasCamera', cameraStatus);
  },

  // 保存视频患者数据
  [type.SET_VIDEO_PATIENT](state, { videoPatient }) {
    state.reservePatientList = videoPatient;
    Vue.prototype.$session.save('reservePatientList', videoPatient);
  },

  // 保存医生token信息
  [type.SET_DOCTOR_TOKEN](state, doctorToken) {
    state.doctorToken = doctorToken;
    Vue.prototype.$session.save('doctorToken', doctorToken);
  },

  // 清除医生token信息
  [type.CLEAR_CLINIC_TOKEN](state) {
    state.doctorToken = null;
    Vue.prototype.$session.remove('doctorToken');
  },
  
  // 保存首页医生信息
  [type.SAVEDOCTORINDEX](state, { doctorIndexInfo }) {
    state.doctorIndexInfo = doctorIndexInfo;
    Vue.prototype.$session.save('doctorIndexInfo', doctorIndexInfo);
  },
  
  // 保存个人中心医生信息
  [type.SAVEDOCTORCENTER](state, { doctorCenterInfo }) {
    state.doctorCenterInfo = doctorCenterInfo;
    Vue.prototype.$session.save('doctorCenterInfo', doctorCenterInfo);
  },
  //保存切换状态
  [type.TOGGLEINDEX](state, { navIndex }) {
    state.navIndex = navIndex;
    sessionStorage.setItem('navIndex', JSON.stringify(navIndex));
  },
  //选择患者
  [type.CHOOSEPATIENT](state, {
    patientData
  }) {
    state.selectPatient = patientData;
    sessionStorage.setItem('selectPatient', JSON.stringify(patientData));
  },
  //进入视频途径
  [type.ENTERROOMWAY](state, {
    seeType
  }) {
    state.seeType = seeType;
    sessionStorage.setItem('seeType', seeType)
  },
  //保存问诊单详情
  [type.SAVEINQUIRY](state, {
    detailData
  }){
    state.inquiryDetail = detailData;
    Vue.prototype.$session.save('inquiryDetail', detailData);
  },
  // 选择药方
  [type.SELECTMEDICAL] (state, { selectMedical }) {
    state.selectMedical = selectMedical;
  }
}



// WEBPACK FOOTER //
// ./src/store/common/mutations.js